var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBinance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#F3BA2F",
  clipPath: "url(#binance_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#F3BA2F",
  strokeWidth: 1.33,
  d: "m15.707 6.146-1.32 1.32-3.414-3.415-.471-.47-.47.47-3.415 3.412-1.32-1.318L10.503.94z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.5 10.001 2.259-2.259 2.259 2.26-2.26 2.258zM6.618 11.595l3.884 3.885 3.887-3.886 2.26 2.257h-.002L10.503 20l-6.145-6.143-.004-.003zM15.98 10.001l2.26-2.259 2.258 2.26-2.259 2.258z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.794 9.999-2.292-2.294L8.807 9.4l-.196.194-.4.402-.004.003.003.005 2.292 2.29L12.794 10h.002z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "binance_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h20v20H.5z"
})))));
export default SvgBinance;